import { ReactComponent as MaskHero } from "../assets/images/mask_hero.svg";

import { useNavigate } from "react-router-dom";
import { GlowButton, OutlineButton } from "../components";
import "react-multi-carousel/lib/styles.css";

import styles from "./styles/mask.module.scss";

import MaskPartsURL from "../assets/images/mask_parts.svg";
import CloudBackground from "../assets/images/cloud_background.svg";
import GreenStripes from "../assets/images/green_stripes.svg";
import RunningStairs from "../assets/images/running_stairs.jpg";
import Strings from "../strings/strings";

export const MaskSection = (className: React.HTMLAttributes<HTMLDivElement>) => {
  const navigate = useNavigate();
  const Carousel = require("react-multi-carousel").default;

  const responsiveCarousel = {
    desktop: {
      breakpoint: { max: 3000, min: 1280 },
      items: 4,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1280, min: 800 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 800, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <>
      <div className={styles.carousel}>
        <div id="maskSection" className={styles.titleSection}>
          <span className={styles.title}>
            {Strings.maskCleanOne}
            <br />
            <span className={styles.blueHighligh}>{Strings.maskCleanTwo}</span>
          </span>
          <div className={styles.subtitle}>{Strings.maskCleanSubtitle}</div>
        </div>
        <Carousel
          responsive={responsiveCarousel}
          keyBoardControl={true}
          infinite={true}
          rtl={false}
          slidesToSlide={1}
        >
          <div className={styles.longBox} style={{ backgroundImage: `url(${CloudBackground})` }}>
            <div className={styles.content}>
              <div className={styles.boxTitle}>{Strings.maskTakeControllOne}</div>
            </div>
            <div className={styles.longsectionImage}>
              <MaskHero height={"250px"} />
            </div>
          </div>
          <div
            className={styles.boxBottom}
            style={{
              backgroundImage: `url(${GreenStripes})`,
            }}
          >
            <div className={styles.content}>
              <div className={styles.boxTitle}>{Strings.maskEngineredTitle}</div>
            </div>
            <div className={styles.sectionImage}>
              <img src={MaskPartsURL} alt="Mask parts" width="100%" />
            </div>
          </div>
          <div className={styles.box} style={{ backgroundImage: `url(${RunningStairs})` }}>
            <div className={styles.content} style={{ height: "100%" }}>
              <div>
                <div className={styles.boxTitle}>{Strings.maskCityBuildTitle}</div>
              </div>
              <OutlineButton
                text={Strings.maskCityBuildBtn}
                onClick={() => navigate("/products")}
              />
            </div>
          </div>
        </Carousel>
        <div className={`${styles.underCarouselBox} ${styles.preOrderSection}`}>
          <div className={styles.content}>
            <div className={styles.boxTitleCenter}>{Strings.maskTryFaceMask}</div>
            <div className={styles.buttonCenter}>
              <GlowButton text={Strings.maskInterestedBtn} onClick={() => navigate("/products")} />
            </div>
          </div>
        </div>
      </div>
      <div {...className}>
        <div className={styles.wrapper}>
          <div id="maskSection" className={styles.titleSection}>
            <span className={styles.title}>
              {Strings.maskCleanOne}
              <br />
              <span className={styles.blueHighligh}>{Strings.maskCleanTwo}</span>
            </span>
            <div className={styles.subtitle}>{Strings.maskCleanSubtitle}</div>
          </div>
          <div className={styles.longBox} style={{ backgroundImage: `url(${CloudBackground})` }}>
            <div className={styles.content}>
              <div className={styles.boxTitle}>{Strings.maskTakeControllOne}</div>
            </div>
            <div className={styles.longsectionImage}>
              <MaskHero height={"250px"} />
            </div>
          </div>
          <div
            className={styles.boxBottom}
            style={{
              backgroundImage: `url(${GreenStripes})`,
            }}
          >
            <div className={styles.content}>
              <div className={styles.boxTitle}>{Strings.maskEngineredTitle}</div>
            </div>
            <div className={styles.sectionImage}>
              <img src={MaskPartsURL} alt="Mask parts" width="100%" />
            </div>
          </div>
          <div className={styles.box} style={{ backgroundImage: `url(${RunningStairs})` }}>
            <div className={styles.content} style={{ height: "100%" }}>
              <div>
                <div className={styles.boxTitle}>{Strings.maskCityBuildTitle}</div>
              </div>
              <OutlineButton
                text={Strings.maskCityBuildBtn}
                onClick={() => navigate("/products")}
              />
            </div>
          </div>
          <div className={`${styles.box} ${styles.preOrderSection}`}>
            <div className={styles.content}>
              <div className={styles.boxTitleCenter}>{Strings.maskTryFaceMask}</div>
              <div className={styles.buttonCenter}>
                <GlowButton
                  text={Strings.maskInterestedBtn}
                  onClick={() => navigate("/products")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
